import styled from 'styled-components'
import { Colors } from '../../../values/colors'

export const TitleHeader = styled.h1`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 10.98px;
  color: ${Colors.blueGray2};
`;

export const Description = styled.p`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20.48px;
  color: ${Colors.blueMist};
  margin-top: 14px;
  margin-bottom: 26px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => props.justify};
  padding-right: 2rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
  margin-left: 22px;
`;
